export const HISTORY_LOG_TABLE_TITLE = 'Change History Log';

export const standardAIData = [
  {
    key: 'source',
    value: 'Conviva',
    exampleText: 'e.g.: my_source_ID',
  },
  {
    key: 'version',
    value: '1.0.0',
    exampleText: 'e.g.: my_version',
  },
  {
    key: 'alert_source',
    value: 'AI Alert',
    exampleText: 'e.g.: alert_from',
  },
  {
    key: 'event_id',
    value: 1,
    exampleText: 'e.g.: my_event_id',
  },
  {
    key: 'account_name',
    value: 'Test Account',
    exampleText: 'e.g.: my_account',
  },
  {
    key: 'root_cause',
    value: 'Test Webhook Configuration',
    exampleText: 'e.g.: urgency',
  },
  {
    key: 'cumulative_impacted_unique_devices',
    value: 1,
    exampleText: 'e.g.: my_metric',
  },
  {
    key: 'diagnostic_report_url',
    value: 'https://test.com',
    exampleText: 'e.g.: my_condition',
  },
  {
    key: 'metric_name',
    value: 'Test metric name',
    exampleText: 'e.g.: my_filter',
  },
  {
    key: 'alert_time',
    value: 'Oct 25 2017 12: 22',
    exampleText: 'e.g.: occurred_at',
  },
  {
    key: 'severity',
    value: 'info',
    exampleText: 'e.g.: criticality',
  },
  {
    key: 'value',
    value: '12%',
    exampleText: 'e.g.: metric_value',
  },
];

export const standardMAData = [
  {
    key: 'metric_name',
    value: 'Test metric name',
    exampleText: 'e.g.: my_metric',
  },
  {
    key: 'event_id',
    value: 1,
    exampleText: 'e.g.: my_event_id',
  },
  {
    key: 'filter_name',
    value: 'Test filter',
    exampleText: 'e.g.: my_filter',
  },
  {
    key: 'diagnostic_report_url',
    value: 'https://test.com',
    exampleText: 'e.g.: my_condition',
  },
  {
    key: 'priority',
    value: 'p1',
    exampleText: 'e.g.: my_condition',
  },
  {
    key: 'source',
    value: 'Conviva',
    exampleText: 'e.g.: my_source_ID',
  },
  {
    key: 'alert_id',
    value: 1,
    exampleText: 'e.g.: my_alert_id',
  },
  {
    key: 'version',
    value: '1.0.0',
    exampleText: 'e.g.: my_version',
  },
  {
    key: 'alert_time',
    value: 'Oct 25 2017 12: 22',
    exampleText: 'e.g.: occurred_at',
  },
  {
    key: 'condition',
    value: '9.4 > 1.0',
    exampleText: 'e.g.: my_condition',
  },
  {
    key: 'filter_id',
    value: 56523,
    exampleText: 'e.g.: my_filter_id',
  },
  {
    key: 'account_name',
    value: 'Test Account',
    exampleText: 'e.g.: my_account',
  },
  {
    key: 'alert_source',
    value: 'Manual Alert',
    exampleText: 'e.g.: alert_from',
  },
];

export const maOpsFields = [
  {
    key: 'sample_size',
    value: '1000 minutes',
    exampleText: 'e.g.: my_sample_size',
  },
  {
    key: 'alert_name',
    value: 'Test alert name',
    exampleText: 'e.g.: my_alert_name',
  },
  {
    key: 'configured_samples',
    value: '200 minutes',
    exampleText: 'e.g.: my_configured_samples',
  },
  {
    key: 'cool_down',
    value: '15 minutes',
    exampleText: 'e.g.: my_cool_down',
  },
];

export const AuthType = {
  credential: 'credential',
  token: 'token',
  custom: 'custom',
};
